import * as Yup from "yup";

export const schema = () => {
  return Yup.object().shape({
    coupon_id: Yup.string().required("Debes ingrear un códig de cupón"),
  });
};

interface FormValues {
  coupon_id: string;
}

export const initialValues: FormValues = {
  coupon_id: "",
};
